module.exports = "https://s.pinimg.com/webapp/style/images/EL@2x-80101419.png";